import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/commons/Icon';

import { Wrapper, Group, Button } from './styles';

const TimesButtonGroup = ({
  buttons,
  changePeriod,
  setDate,
  date,
  currentTerm,
}) => {
  const [filter, setFilter] = useState(currentTerm || 'week');

  const handleOnClick = id => {
    setFilter(id);
    if (setDate) {
      setDate({ ...date, custom: {} });
    }
    if (changePeriod) {
      switch (id) {
        case 'max':
          changePeriod('max');
          break;
        case 'year':
          changePeriod('year');
          break;
        case 'quarter':
          changePeriod('quarter');
          break;
        case 'month':
          changePeriod('month');
          break;
        case 'week':
          changePeriod('week');
          break;
        case 'day':
          changePeriod('day');
          break;
        default:
          changePeriod('week');
      }
    }
  };
  const renderFilterButton = button => (
    <Button
      key={button.id}
      onClick={() => handleOnClick(button.id)}
      style={
        filter === button.id
          ? { background: '#F3FAF7', color: '#35A47C' }
          : null
      }
    >
      {filter === button.id && (
        <Icon name="filterArrow" style={{ marginRight: '5px' }} />
      )}
      <FormattedMessage id={button.name} />
    </Button>
  );

  return (
    <Wrapper>
      <Group>{buttons?.map(button => renderFilterButton(button))}</Group>
    </Wrapper>
  );
};

export default TimesButtonGroup;

TimesButtonGroup.propTypes = {
  setDate: PropTypes.func,
  changePeriod: PropTypes.func,
  date: PropTypes.objectOf(PropTypes.object),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      path: PropTypes.string,
    })
  ).isRequired,
  currentTerm: PropTypes.string,
};

TimesButtonGroup.defaultProps = {
  changePeriod: null,
  setDate: null,
  date: null,
  currentTerm: 'week',
};
